import axios from "axios";
import { toast } from "react-toastify";
import { LOCALSTORAGE_KEYS } from "../../utils/enum";
import { clearLocalStorage, getLocalStorageItemHandler } from "../local-storage";

const { USER_DATA } = LOCALSTORAGE_KEYS;
// Add a request interceptor
axios.interceptors.request.use(
  (config) => {
    const token = getLocalStorageItemHandler(USER_DATA);
    if (token && Object.keys(token).length) {
      if (token?.ssoToken) config.headers["ssoToken"] = token.ssoToken;
    }
    if (token?.session_id) {
      config.headers["sessionId"] = token.session_id;
    }
    config.headers["Content-Type"] = "application/json";
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

//Add a response interceptor
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);
